import { schema } from 'normalizr'
import { AdminExtraModel } from './Admin'

const venueSchema = new schema.Entity('venue')
const venueTypeSchema = new schema.Entity('venueType')
const venueTagSchema = new schema.Entity('venueTag')
const featuredVenueSchema = new schema.Entity('featuredVenue')
const clusterSchema = new schema.Entity('cluster')
const venuesCollectionSchema = new schema.Entity('venuesCollection')

const seatingAreaSchema = new schema.Entity('seatingArea')
const venueSeatingAreaSchema = new schema.Entity('venueSeatingArea')

const userSchema = new schema.Entity('user')
const menuSchema = new schema.Entity('menu')
const adminSchema = new schema.Entity('admin')
const externalBookingAPIKeySchema = new schema.Entity('externalBookingAPIKey')
const adminInviteSchema = new schema.Entity('adminInvite')
const roleSchema = new schema.Entity('role')
const permissionSchema = new schema.Entity('permission')
const loyaltyTierSchema = new schema.Entity('loyaltyTier')
const legalDocumentSchema = new schema.Entity('legalDocument')
const legalDocumentVersionSchema = new schema.Entity('legalDocumentVersion')
const settingSchema = new schema.Entity('setting')
const notificationContentSchema = new schema.Entity('notificationContent')
const audienceSchema = new schema.Entity('audience')
const testUsersSchema = new schema.Entity('testUsers')
const notificationSchema = new schema.Entity('notification')
const WhatsappBotSettingSchema = new schema.Entity('whatsappBotSetting')
const eventSchema = new schema.Entity('event')
const eventParticipationSchema = new schema.Entity('eventParticipation')
const eventParticipationStatusSchema = new schema.Entity(
  'eventParticipationStatus'
)
const reservationSchema = new schema.Entity('reservation')
const eventsCollectionSchema = new schema.Entity('eventsCollection')
const segmentSchema = new schema.Entity('segment')

/** INTEGRATION **/
const venueIntegrationSchema = new schema.Entity('venueIntegration')
const sevenroomsAudienceSchema = new schema.Entity('sevenroomsAudience')
const sevenroomsVenueGroupSchema = new schema.Entity('sevenroomsVenueGroup')
const dominoConfigSchema = new schema.Entity('dominoConfig')
const adyenConfigSchema = new schema.Entity('adyenConfig')

/** MEMBERSHIP **/
const programSchema = new schema.Entity('program')
const formQuestionSchema = new schema.Entity('formQuestion')
const formQuestionOptionSchema = new schema.Entity('formQuestionOption')
const formAnswerSchema = new schema.Entity('formAnswer')
const subscriptionSchema = new schema.Entity('subscription')
const membershipTransactionSchema = new schema.Entity('membershipTransaction')
const membershipIncomingRenewalSchema = new schema.Entity(
  'membershipIncomingRenewal'
)
const membershipProfileSchema = new schema.Entity('membershipProfile')
const planSchema = new schema.Entity('plan')
const couponSchema = new schema.Entity('coupon')
const perkSchema = new schema.Entity('perk')
const membershipProfileTagSchema = new schema.Entity('membershipProfileTag')
const subscriptionTagSchema = new schema.Entity('subscriptionTag')
const programComplementaryItemSchema = new schema.Entity(
  'programComplementaryItem'
)
const programCurrencySchema = new schema.Entity('programCurrency')
const membershipProfileComplementaryItemSchema = new schema.Entity(
  'membershipProfileComplementaryItem'
)
const membershipProfileCurrencySchema = new schema.Entity(
  'membershipProfileCurrency'
)

/** Business **/
const companySchema = new schema.Entity('company')
const companyContactSchema = new schema.Entity('companyContact')
const companyStatusSchema = new schema.Entity('companyStatus')
const businessProfileStatusSchema = new schema.Entity('businessProfileStatus')
const policySchema = new schema.Entity('policy')
const businessProfileSchema = new schema.Entity('businessProfile')
const shiftSchema = new schema.Entity('shift')
const daySchema = new schema.Entity('day')
const billingMethodSchema = new schema.Entity('billingMethod')
const businessVerifierSchema = new schema.Entity('businessVerifier')

const currencySchema = new schema.Entity('currency')

/** BALANCE **/
const complementaryItemSchema = new schema.Entity('complementaryItem')

adminInviteSchema.define({
  role: roleSchema,
})

roleSchema.define({})

adminSchema.define({
  roles: [roleSchema],
  extraModels: [
    {
      model: new schema.Union(
        {
          membershipPlan: planSchema,
        },
        (value: any, parent: AdminExtraModel, key: string) => parent.entity
      ),
    },
  ],
})

externalBookingAPIKeySchema.define({})

venueSchema.define({
  type: venueTypeSchema,
  tags: [venueTagSchema],
  dominoConfig: dominoConfigSchema,
  businessVerifiers: [businessVerifierSchema],
})
venueTypeSchema.define({})

seatingAreaSchema.define({
  //
})

venuesCollectionSchema.define({
  venues: [venueSchema],
  venue: venueSchema,
})

venueTagSchema.define({
  //
})

clusterSchema.define({
  venues: [venueSchema],
})

featuredVenueSchema.define({
  venue: venueSchema,
  venues: [venueSchema],
})

venueSeatingAreaSchema.define({
  venue: venueSchema,
  seatingArea: seatingAreaSchema,
})

loyaltyTierSchema.define({})

legalDocumentSchema.define({})

legalDocumentVersionSchema.define({
  legalDocument: legalDocumentSchema,
})

userSchema.define({
  loyaltyTiers: [loyaltyTierSchema],
  businessProfile: businessProfileSchema,
})

audienceSchema.define({})

testUsersSchema.define({})

menuSchema.define({})

notificationContentSchema.define({})

notificationSchema.define({})
WhatsappBotSettingSchema.define({})

programSchema.define({
  plans: [planSchema],
  currency: currencySchema,
  paymentIntegration: adyenConfigSchema,
  loyaltyTier: loyaltyTierSchema,
})

formQuestionSchema.define({
  options: [formQuestionOptionSchema],
})
formQuestionOptionSchema.define({})

formAnswerSchema.define({})

membershipProfileSchema.define({
  subscription: subscriptionSchema,
  appUser: userSchema,
  tags: [membershipProfileTagSchema],
  complementaryItems: [membershipProfileComplementaryItemSchema],
})

subscriptionSchema.define({
  membershipProfiles: [membershipProfileSchema],
  coupon: couponSchema,
  tags: [subscriptionTagSchema],
})

// member/plan are denormalized read-model fields (not references), left
// embedded as-is.
membershipTransactionSchema.define({})
membershipIncomingRenewalSchema.define({})

couponSchema.define({
  plans: [planSchema],
})

perkSchema.define({
  plans: [planSchema],
})

complementaryItemSchema.define({
  programs: [programSchema],
})

programComplementaryItemSchema.define({
  complementaryItem: complementaryItemSchema,
})

programCurrencySchema.define({
  currency: currencySchema,
})

membershipProfileComplementaryItemSchema.define({
  complementaryItem: complementaryItemSchema,
})

membershipProfileCurrencySchema.define({
  currency: currencySchema,
})

planSchema.define({})

membershipProfileTagSchema.define({})

subscriptionTagSchema.define({})

eventSchema.define({
  venue: venueSchema,
  participations: [eventParticipationSchema],
  membershipPlans: [planSchema],
})

eventParticipationSchema.define({
  membershipProfile: membershipProfileSchema,
  event: eventSchema,
  status: eventParticipationStatusSchema,
})

eventParticipationStatusSchema.define({})

eventsCollectionSchema.define({
  events: [eventSchema],
})

companySchema.define({
  status: companyStatusSchema,
  policies: [policySchema],
  contacts: [companyContactSchema],
  businessProfiles: [businessProfileSchema],
})
companyContactSchema.define({})
companyStatusSchema.define({})
businessProfileStatusSchema.define({})
policySchema.define({
  policyShifts: [
    { billingMethod: billingMethodSchema, day: daySchema, shift: shiftSchema },
  ],
})
businessProfileSchema.define({
  status: businessProfileStatusSchema,
  company: companySchema,
  appUser: userSchema,
})
reservationSchema.define({
  venue: venueSchema,
  company: companySchema,
  user: userSchema,
  businessProfile: businessProfileSchema,
})
shiftSchema.define({})
daySchema.define({})
billingMethodSchema.define({})
businessVerifierSchema.define({ venue: venueSchema })

venueIntegrationSchema.define({})
sevenroomsAudienceSchema.define({})
sevenroomsVenueGroupSchema.define({})
dominoConfigSchema.define({
  venue: venueSchema,
})
adyenConfigSchema.define({})

currencySchema.define({})

segmentSchema.define({})

export {
  adminInviteSchema,
  adminSchema,
  adyenConfigSchema,
  audienceSchema,
  billingMethodSchema,
  businessProfileSchema,
  businessProfileStatusSchema,
  businessVerifierSchema,
  clusterSchema,
  companyContactSchema,
  companySchema,
  companyStatusSchema,
  complementaryItemSchema,
  couponSchema,
  currencySchema,
  daySchema,
  dominoConfigSchema,
  eventParticipationSchema,
  eventParticipationStatusSchema,
  eventSchema,
  eventsCollectionSchema,
  externalBookingAPIKeySchema,
  featuredVenueSchema,
  formAnswerSchema,
  formQuestionOptionSchema,
  formQuestionSchema,
  legalDocumentSchema,
  legalDocumentVersionSchema,
  loyaltyTierSchema,
  membershipIncomingRenewalSchema,
  membershipProfileComplementaryItemSchema,
  membershipProfileCurrencySchema,
  membershipProfileSchema,
  membershipProfileTagSchema,
  membershipTransactionSchema,
  menuSchema,
  notificationContentSchema,
  notificationSchema,
  perkSchema,
  permissionSchema,
  planSchema,
  policySchema,
  programComplementaryItemSchema,
  programCurrencySchema,
  programSchema,
  reservationSchema,
  roleSchema,
  seatingAreaSchema,
  segmentSchema,
  settingSchema,
  sevenroomsAudienceSchema,
  sevenroomsVenueGroupSchema,
  shiftSchema,
  subscriptionSchema,
  subscriptionTagSchema,
  testUsersSchema,
  userSchema,
  venueIntegrationSchema,
  venueSchema,
  venuesCollectionSchema,
  venueSeatingAreaSchema,
  venueTagSchema,
  venueTypeSchema,
  WhatsappBotSettingSchema,
}
